import isEmpty from "lodash/isEmpty";
import { usePaywallCheckoutContext } from "@/react/contexts/Paywalls/paywallCheckoutContext";
import { isBuyNowPayLater } from "@/react/helpers/paywallCheckoutHelpers";
import { CheckoutFormBusinessNameField } from "../../CheckoutV2/CheckoutForm/CheckoutFormBusinessNameField";
import { CheckoutFormNameField } from "../CheckoutFormNameField";
import { AddressElement } from "./AddressElement";
import { PaymentElement } from "./PaymentElement";
import { useIsPaymentElementRequired } from "./useIsPaymentElementRequired";

export const Elements = () => {
  const {
    currentUser,
    isMemberAddressRequired,
    memberBillingInfo,
    stripePaymentMethodType: paymentMethodType,
  } = usePaywallCheckoutContext();

  const isPaymentElementRequired = useIsPaymentElementRequired();

  const isAddressMissing = !currentUser || isEmpty(memberBillingInfo);
  const isAddressRequired =
    isMemberAddressRequired || isBuyNowPayLater(paymentMethodType);
  const isAddressElementRequired = isAddressRequired && isAddressMissing;
  const isNameFieldRequired = !isAddressElementRequired && !currentUser;
  const shouldShowBusinessNameField = !memberBillingInfo?.business_name;

  return (
    <>
      {isPaymentElementRequired && <PaymentElement />}
      {isAddressElementRequired && <AddressElement />}
      {isNameFieldRequired && <CheckoutFormNameField />}
      {shouldShowBusinessNameField && <CheckoutFormBusinessNameField />}
    </>
  );
};
